import type { ConfigRequirement } from '@/features/integrations/integrations.types';

export interface RequirementInput {
  args: string[];
  envs: { key: string; value: string }[];
  headers: { key: string; value: string }[];
}

export interface UnmetRequirement {
  type: string;
  message: string;
  name?: string;
}

export function evaluateRequirements(
  requirements: ConfigRequirement[],
  input: RequirementInput
): UnmetRequirement[] {
  const unmet: UnmetRequirement[] = [];

  for (const req of requirements) {
    if (req.type === 'min_args') {
      const filled = input.args.filter((arg) => arg.trim() !== '').length;
      if (filled < req.min) {
        unmet.push({ type: req.type, message: req.message });
      }
    } else {
      const rows = req.type === 'env' ? input.envs : input.headers;
      const satisfied = rows.some(
        (row) =>
          row.key.trim().toLowerCase() === req.name.toLowerCase() &&
          row.value.trim() !== ''
      );
      if (!satisfied) {
        unmet.push({ type: req.type, message: req.message, name: req.name });
      }
    }
  }

  return unmet;
}
